import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAdminLoanToDisburse, useAdminBank, useDisburseLoan } from "../../hooks/useAdmin";
import Card from "../../components/ui/Card";
import Badge from "../../components/ui/Badge";
import Button from "../../components/ui/Button";

const fmt = (n:number) => new Intl.NumberFormat("en-NG",{style:"currency",currency:"NGN", currencyDisplay:"symbol",maximumFractionDigits:0}).format(n);

const fmtDate = (d:string) => d ? new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "—";

export default function LoanDisbursalPage() {
  const { id }   = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const { data: loan, isPulling }     = useAdminLoanToDisburse(id!)        as any;
  const surety = loan?.[0].sureties ?? [];

  const { data: banks = [], isLoading } = useAdminBank(loan?.[0].borrower_id!) as any;
  const updateLoanDisbursed = useDisburseLoan();

  const handleDisburse = () =>{
    const totalAmount = Number(loan?.[0].amount) + Number((loan?.[0].interest_rate/100) * loan?.[0].amount);
    updateLoanDisbursed.mutate({id:id,totalAmount:totalAmount});
    navigate('/admin/loans');
  };

  return (
    <div>
      <Button variant="outline" size="sm" onClick={() => navigate("/admin/loans")} className="mb-5">← Back</Button>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 mb-4">
        {/* Profile */}
        <div className="lg:col-span-3 space-y-4">
          <Card>
            <p className="text-sm font-medium text-slate-700 mb-3">Approved Loan for Disbursal</p>
            
            <table className="w-full border-collapse" style={{marginBottom:"20px"}}>
              
                {isPulling? 
                  <tbody><tr><td colSpan={2}><p>Loading data...</p></td></tr></tbody> :
                  <tbody>
                    <tr className="border-b border-slate-100"><td>Name: </td><td>{loan?.[0].first_name} {loan?.[0].last_name}</td></tr>
                    <tr className="border-b border-slate-100"><td>Loan Amount: </td><td><p className="text-sm text-emerald-600">{fmt(loan?.[0].amount)}</p></td></tr>
                    <tr className="border-b border-slate-100"><td>Interest Rate: </td><td>{loan?.[0].interest_rate}</td></tr>
                    <tr className="border-b border-slate-100"><td>Amount to Repay: </td><td><p className="text-sm text-emerald-600">{fmt(Number(loan?.[0].amount) + Number((loan?.[0].interest_rate/100) * loan?.[0].amount))}</p></td></tr>
                    <tr className="border-b border-slate-100"><td>Surety 1:</td><td>{surety?.[0]?.name?? ""} ({surety?.[0]?.status?? ""})</td></tr>
                    <tr className="border-b border-slate-100"><td>Surety 2:</td><td>{surety?.[1]?.name?? ""} ({surety?.[1]?.status?? ""})</td></tr>
                  </tbody>
                }
            </table>
            <Button size="md" onClick={handleDisburse}>Disburse Loan</Button>
          </Card>
          
        </div>

        <Card className="lg:col-span-2">
          <p className="text-sm font-medium text-slate-700 mb-3">Member Bank Details</p>
          <div className="flex gap-4 items-center mb-5">            
              {isLoading? <p>No bank found...</p> :(
                    banks.map((a:any) => (
                      <div key={a.id} className="flex justify-between items-center py-2.5 border-b border-slate-100 last:border-0">
                        <div className="flex gap-3 items-center">
                          <span className="text-xl">🏦</span>
                          <div>
                            <p className="text-sm text-slate-700">{a.bank}</p>
                            <p className="text-xs text-slate-400">{a.account_type} {a.account_no}</p>
                          </div>
                        </div>
                        <Badge label="Linked" color="emerald"/>
                      </div>
                    ))
              )}
          </div>          
        </Card>
        
      </div>

    </div>
  );
}
